export default __webpack_public_path__ + "89315028cae3aae46ee72a83001c2546.png";